import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Profile = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Cette page sert uniquement de point de redirection après login social
    // Une fois l'authentification traitée, rediriger vers la page d'accueil
    if (!loading) {
      if (user && user.authenticated) {
        // Utilisateur authentifié, rediriger vers l'accueil
        navigate('/home', { replace: true });
      } else {
        // Pas d'authentification, rediriger vers la page d'auth
        navigate('/auth', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background via-background/90 to-primary/5 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Traitement de l'authentification...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background/90 to-primary/5 flex items-center justify-center">
      <div className="text-center">
        <p className="text-muted-foreground">Redirection en cours...</p>
      </div>
    </div>
  );
};

export default Profile;